import { Component } from '@angular/core';
import { DataService } from '../services/data.service';
import { MessageService } from '../services/message.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-accounting',
  templateUrl: './accounting.component.html',
  styleUrls: ['./accounting.component.css'],
})
export class AccountingComponent {
  url: string = 'accountings';
  //urlTwo: string = 'personnel';
  data: Array<any> = [];
  personnel: Array<any> = [];

  currentPage: number = 1;
  morePages: boolean = true;
  itemsPerPage: number = 15;
  year = '';
  //type = 'external';
  total = 0;
  totalConductores = 0;
  totalActivos = 0;
  totalInactivos = 0;
  ultimoRegistro = '-';
  totalNumber = 0;
  byCities = 0;
  active = 0;
  busy = 0;
  pending = 0;
  sanctioned = 0;
  filter = 2;
  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      desc: 'Staff &+',
      //route: null,
      route: '/numbers/accounting',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Tax compliance',
      route: null,
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Invoices ',
      route: '/numbers/accounting/invoices',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Bills',
      route: '/numbers/accounting/external',
    },
  ];

  resumenCardsTwo = [
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Finance',
      route: '/numbers',
    },
    {
      label: '',
      value: 0,
      icon: 'fa-solid fa-building-columns',
      bgClass: 'bg-white',
      desc: 'Accounting',
      route: '/numbers/accounting',
    },
  ];

  searchText = '';
  filteredData: Array<any> = [];
  sugerenciasBusqueda: string[] = [];
  //redirect = false;

  frequencyMap = {
    1: 'oneTime',
    2: 'daily',
    3: 'week',
    4: 'monthly',
    5: 'yearly',
  };

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.getData();
    /*console.log('URL actual:', this.router.url);
    const currentPath = this.router.url.split('/')[2];
    console.log('path:', currentPath);
  
     if (currentPath === 'internal') {
      //this.type = 'internal';
      //this.redirect = true;
      this.getInternal();
    } else {
      //this.type = 'external';
      //this.getData();
      this.getExternal();
    }
    console.log('type', this.type); */
  }

  getStats() {
    this.totalConductores = this.data.length;
    this.totalActivos = this.data.filter((d) => d.status).length;
    this.totalInactivos = this.data.filter((d) => !d.status).length;
    this.ultimoRegistro = this.data.length
      ? this.data[this.data.length - 1].firstname +
        ' ' +
        this.data[this.data.length - 1].lastname
      : '-';
  }

  getResumenEstados() {
    //this.totalNumber = this.data.length;
    this.byCities = new Set(this.data.map((d) => d.city)).size;
    this.active = this.data.filter((d) => d.status === 'active').length;
    this.busy = this.data.filter((d) => d.status === 'busy').length;
    this.pending = this.data.filter((d) => d.status === 'pending').length;
    this.sanctioned = this.data.filter((d) => d.status === 'sanctioned').length;

    /* this.resumenCards[0].value = this.totalConductores;
    this.resumenCards[1].value = 0;
    this.resumenCards[2].value = this.totalActivos;
    this.resumenCards[3].value = this.busy;
    this.resumenCards[4].value = this.totalInactivos;
    this.resumenCards[5].value = this.sanctioned; */
  }

  filterInfo() {
    const texto = this.searchText.trim().toLowerCase();
    if (!texto) {
      this.filteredData = [...this.data];
    } else {
      this.filteredData = this.data.filter((item) => {
        return (
          item.description && item.description.toLowerCase().includes(texto)
          //(item.lastname && item.lastname.toLowerCase().includes(texto)) ||
          //(item.phone && item.phone.toLowerCase().includes(texto)) ||
          //(item.role &&
          //  item.role.name &&
          //  item.role.name.toLowerCase().includes(texto)) ||
          //(item.rol_user && item.rol_user.toLowerCase().includes(texto)) ||
          //(item.state && item.state.toLowerCase().includes(texto)) ||
          //(item.city && item.city.toLowerCase().includes(texto))
        );
      });
    }
    this.getStatsFiltrado();
    this.getResumenEstadosFiltrado();
  }

  getStatsFiltrado() {
    /* this.totalConductores = this.filteredData.length;
    this.totalActivos = this.filteredData.filter((d) => d.status).length;
    this.totalInactivos = this.filteredData.filter((d) => !d.status).length;
    this.ultimoRegistro = this.filteredData.length
      ? this.filteredData[this.filteredData.length - 1].firstname +
        ' ' +
        this.filteredData[this.filteredData.length - 1].lastname
      : '-'; */
  }

  getResumenEstadosFiltrado() {
    /* this.totalNumber = this.filteredData.length;
    this.byCities = new Set(this.filteredData.map((d) => d.city)).size;
    this.active = this.filteredData.filter((d) => d.status === 'active').length;
    this.busy = this.filteredData.filter((d) => d.status === 'busy').length;
    this.pending = this.filteredData.filter(
      (d) => d.status === 'pending'
    ).length;
    this.sanctioned = this.filteredData.filter(
      (d) => d.status === 'sanctioned'
    ).length;

    this.resumenCards[0].value = this.totalConductores;
    this.resumenCards[1].value = this.byCities;
    this.resumenCards[2].value = this.totalActivos;
    this.resumenCards[3].value = this.busy;
    this.resumenCards[4].value = this.totalInactivos;
    this.resumenCards[5].value = this.sanctioned; */
  }

  actualizarSugerencias() {
    const sugerenciasSet = new Set<string>();
    this.data.forEach((item) => {
      if (item.description) sugerenciasSet.add(item.description);
      //if (item.lastname) sugerenciasSet.add(item.lastname);
      //if (item.phone) sugerenciasSet.add(item.phone);
      //if (item.role && item.role.name) sugerenciasSet.add(item.role.name);
      //if (item.rol_user) sugerenciasSet.add(item.rol_user);
      //if (item.state) sugerenciasSet.add(item.state);
      //if (item.city) sugerenciasSet.add(item.city);
    });
    this.sugerenciasBusqueda = Array.from(sugerenciasSet).filter(Boolean);
  }

  /* getData(): void {
    this.dataService.getData(`${this.url}`).subscribe((response) => {
      console.log('response en accounting', response);
      if (response) {
        this.data = response.data;
        this.filteredData = [...this.data];
        console.log('filteredData', this.filteredData);
        this.getStats();
        this.getResumenEstados();
        this.actualizarSugerencias();
      } else {
        this.messageService.add(response.msg, 'danger');
      }
    });
  } */

  getData(): void {
    this.dataService
      .getDataTwo(this.url, '', '', this.currentPage, this.itemsPerPage)
      .subscribe((response) => {
        //console.log('response en accounting', response);

        if (response) {
          this.data = response.data;
          this.morePages = response.data.length === this.itemsPerPage;
          //this.filteredData = [...this.data];

          this.filteredData = this.data.map((item: any) => {
            const key = this.frequencyMap[item.frequency];
            const formattedValue = (value: any) =>
              value + (item.dueDate ? ` (${item.dueDate})` : '');

            //daily: key === 'daily' ? item.value + ' ('+ item.dueDate +')' : '',
            return {
              ...item, // conserva todos los campos originales
              oneTime: key === 'oneTime' ? formattedValue(item.value) : '',
              daily: key === 'daily' ? formattedValue(item.value) : '',
              week: key === 'week' ? formattedValue(item.value) : '',
              //biweek: key === 'biweek' ? formattedValue(item.value) : '',
              monthly: key === 'monthly' ? formattedValue(item.value) : '',
              yearly: key === 'yearly' ? formattedValue(item.value) : '',
            };
          });
          this.total = response.total;
          this.year = response.year;
          //console.log('filteredData', this.filteredData);
          this.getStats();
          this.getResumenEstados();
          this.actualizarSugerencias();
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  deleteData(id: string): void {
    if (!confirm('¿Desea eliminar el registro?')) {
      return;
    }

    this.dataService
      .deleteData(`${this.url}/delete/${id}`)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }

        this.getData();
      });
  }

  nextPage(): void {
    this.currentPage++;
    this.getData();
  }

  prevPage(): void {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.getData();
    }
  }

  /* handleCardClick(index: number): void {
    if (index === 0) {
      this.getInternal();
    } else if (index === 1) {
      this.getExternal();
    }
  } */

  /* getInternal() {
    this.getDataPersonnel();
    console.log('click en internal');
    this.type = 'internal';
    this.redirect = true;
    //setTimeout(()=> {this.getData()},500);
    this.getData();
  } */

  /* getExternal() {
    console.log('click en external');
    this.type = 'external';
    this.redirect = false;
    //setTimeout(()=> {this.getData()},500);
    this.getData();
  } */

  /* getDataPersonnel(): void {
    this.dataService.getData(this.urlTwo).subscribe((response) => {
      this.personnel = response.data;
      //console.log('get personnel',this.personnel)
    });
  }

  findPersonnel(id: string): string {
    const person = this.personnel.find((person) => person._id === id);
    return person?.firstname || '';
  } */
}
